export const cognitoConfig = {
  UserPoolId: "us-east-1_WlF2KVgTq",
  ClientId: "5b7ad6if1om1kj2gl5qq2jnij9",
};
